/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import React, { Fragment } from 'react';
import { createLogic } from 'redux-logic';
import { SAVE_SUBSCRIPTIONS_ERROR } from 'state/subscriptions/SubscriptionsActions';
import { addToast } from 'state/toast/ToastActions';
import { analyticsActionError } from 'state/analytics/AnalyticsActions';
import { footerLinks } from 'services/Externals';
import { NON_BREAKING_SPACE } from 'services/Formats';

const FailedUpdateSubscriptionsLogic = createLogic({
  type: SAVE_SUBSCRIPTIONS_ERROR,

  // eslint-disable-next-line no-unused-vars
  process({ action }, dispatch, done) {
    // dispatch user message
    const title = '';
    const message = () => {
      return (
        <Fragment>
          Unfortunately, we were unable to save the changes to your
          subscriptions due to an error in our processes. Please try again later
          or{NON_BREAKING_SPACE}
          <a href={footerLinks.contactUsUrl} target="_blank" rel="noreferrer">
            contact us
          </a>
          {NON_BREAKING_SPACE}
          for assistance.
        </Fragment>
      );
    };
    dispatch(addToast(false, title, message));

    // dispatch analytics message
    dispatch(analyticsActionError('SaveSubscriptions'));

    done();
  }
});

export default FailedUpdateSubscriptionsLogic;
